@if (bloquearPantalla()) {
  <p-blockUI [blocked]="true">
    <ng-template #content>
      <div
        style="
          text-align: center;
          background: rgba(5, 29, 45, 0.92);
          border: 1px solid rgba(46, 163, 242, 0.35);
          border-radius: 16px;
          padding: 40px 50px;
          backdrop-filter: blur(6px);
          box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5);
          min-width: 280px;
        "
      >
        <svg
          viewBox="0 0 270 63"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          style="width: auto; height: 36px; display: block; margin: 0 auto 24px"
        >
          <path
            d="M28 6 L50 13 L50 33 C50 46 28 57 28 57 C28 57 6 46 6 33 L6 13Z"
            stroke="#2ea3f2"
            stroke-width="2"
            fill="#2ea3f2"
            fill-opacity="0.18"
            stroke-linejoin="round"
          />
          <polyline
            points="16,31 24,42 40,21"
            stroke="#22c55e"
            stroke-width="5"
            stroke-linecap="round"
            stroke-linejoin="round"
            fill="none"
          />
          <text
            x="60"
            y="44"
            font-family="'Plus Jakarta Sans', -apple-system, sans-serif"
            font-weight="800"
            font-size="34"
            fill="#ffffff"
            letter-spacing="-1"
          >
            CertiFirm
          </text>
        </svg>
        <br />
        @if (authStore.blockuiBoton()) {
          <p-button
            [label]="authStore.blockuiBoton()!.label"
            severity="contrast"
            size="large"
            (onClick)="authStore.ejecutarBotonBlockui()"
            style="margin-top: 8px"
          ></p-button>
        } @else {
          <i
            class="pi pi-spin pi-spinner"
            style="font-size: 2.5rem; color: var(--p-primary-400)"
          ></i>
        }
        <p
          style="
            color: var(--p-primary-300);
            margin-top: 16px;
            margin-bottom: 0;
            font-size: 0.95rem;
            letter-spacing: 0.03em;
          "
        >
          {{ authStore.blockuiMensaje() }}
        </p>
      </div>
    </ng-template>
  </p-blockUI>
}

<app-barra-superior></app-barra-superior>

<router-outlet></router-outlet>

<!-- TOAST MODAL -->
<p-toast #toastmodal sticky="true" position="center">
  <ng-template #message let-message>
    <div style="text-align: center; width: 100%">
      <i class="{{ message.data.icono }}" style="font-size: 3em"></i>
      <h3>{{ message.summary }}</h3>
      <p>{{ message.detail }}</p>
      <!-- <p-button [style]="{'width': '100%'}" label="OK" variant="outlined" [severity]="message.severity === 'error' ? 'danger' : 'success'" (click)="messageService.clear()"></p-button> -->
    </div>
  </ng-template>
</p-toast>

<!-- CONFIRM DIALOG GLOBAL -->
<p-confirmDialog
  [draggable]="false"
  [pt]="{
    root: { style: 'overflow:hidden; background:transparent; border:none; padding:0' },
    content: { style: 'padding:0' },
  }"
>
  <ng-template #headless let-message let-onAccept="onAccept" let-onReject="onReject">
    @if (message) {
      <div
        class="flex flex-col overflow-hidden rounded-2xl shadow-2xl"
        style="background: var(--p-surface-0); width: 380px; max-width: 92vw"
      >
        <!-- Header coloreado según tipo -->
        <div
          class="flex flex-col items-center px-8 pt-8 pb-6 shrink-0 mb-[-2px]"
          style="position: relative; z-index: 1"
          [style.background]="
            message.icon?.includes('check-circle')
              ? 'linear-gradient(135deg,#16a34a,#22c55e)'
              : message.icon?.includes('question')
                ? 'linear-gradient(135deg,#1565aa,#2ea3f2)'
                : 'linear-gradient(135deg,#b91c1c,#ef4444)'
          "
        >
          <div
            class="rounded-full flex items-center justify-center w-16 h-16 mb-4"
            style="
              background: rgba(255, 255, 255, 0.18);
              backdrop-filter: blur(4px);
              border: 2px solid rgba(255, 255, 255, 0.3);
            "
          >
            <i [class]="message.icon" style="font-size: 1.9rem; color: white"></i>
          </div>
          <h2
            class="m-0 text-xl font-bold text-center"
            style="color: white; letter-spacing: 0.01em"
          >
            {{ message.header }}
          </h2>
        </div>

        <!-- Mensaje -->
        <div class="px-7 py-5">
          <p class="m-0 text-center text-base leading-relaxed" style="color: var(--p-text-color)">
            {{ message.message }}
          </p>
        </div>

        <!-- Separador -->
        <div style="height: 1px; background: var(--p-surface-200); margin: 0 1.75rem"></div>

        <!-- Botones -->
        <div class="flex gap-3 px-7 py-5">
          <div class="flex-1">
            <p-button
              [label]="message.rejectLabel || 'Cancelar'"
              variant="outlined"
              severity="secondary"
              (onClick)="onReject()"
              styleClass="w-full"
            ></p-button>
          </div>
          <div class="flex-1">
            <p-button
              [label]="message.acceptLabel || 'Aceptar'"
              [severity]="message.icon?.includes('check-circle') ? 'success' : 'danger'"
              (onClick)="onAccept()"
              styleClass="w-full"
            ></p-button>
          </div>
        </div>
      </div>
    }
  </ng-template>
</p-confirmDialog>

<!-- TOAST NO MODAL - SUPERIOR DERECHA-->
<p-toast
  #toastnomodal
  key="no_modal"
  life="2000"
  sticky="false"
  position="top-right"
  closable="true"
>
  <ng-template #message let-message>
    <div style="text-align: center; width: 100%">
      <i class="{{ message.data.icono }}" style="font-size: 3em"></i>
      <h3>{{ message.summary }}</h3>
      <p>{{ message.detail }}</p>
    </div>
  </ng-template>
</p-toast>
